import * as LJS from '../lib/littlejs.esm.js';
import { vec2 } from '../lib/littlejs.esm.js';
import Globals from './globals.ts';
const CAMERA_OFFSET = -5;
export default class Camera {
    constructor() {
        this.pos = vec2(0, 0);
        this.scale = 16;
        this.zoom = 0;
        this.target = null;
    }
    init(initialPos, initialTarget) {
        this.pos = initialPos.copy();
        this.pos.y += CAMERA_OFFSET;
        this.target = initialTarget;
        // @TODO - Calculate the scale so that the map fills the screen
        // If we don't set a scale and it calculates auto it works, so we can use that
        LJS.setCameraScale(this.scale);
        LJS.setCameraPos(this.pos);
    }
    update() {
        // Check if game is in pause state - if so, don't update camera
        if (Globals.gameState === 'pause') {
            return;
        }
        if (this.target) {
            let newPos = this.pos.copy();
            newPos.y = this.target.pos.y + CAMERA_OFFSET;
            LJS.setCameraPos(newPos);
        }
    }
}
